import { render, staticRenderFns } from "./TablePanel.vue?vue&type=template&id=82938a42&scoped=true"
import script from "./TablePanel.vue?vue&type=script&lang=js"
export * from "./TablePanel.vue?vue&type=script&lang=js"
import style0 from "./TablePanel.vue?vue&type=style&index=0&id=82938a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82938a42",
  null
  
)

export default component.exports